import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { usePublicVendors } from '../services/usePublicVendors';
import { useCustomerAuth } from '../services/CustomerAuthContext';
import { useAuth } from '../services/AuthContext';

function VendorShowcase() {
  const { vendors: allVendors } = usePublicVendors();
  const [vendors, setVendors] = useState([]);
  const { customer } = useCustomerAuth();
  const { vendor: loggedInVendor } = useAuth();
  const tier = customer?.subscriptionTier || 'explorer';
  const vendorHasAccess = loggedInVendor && loggedInVendor.vendorStatus === 'active';
  const hasAccess = vendorHasAccess || tier === 'member' || tier === 'insider';

  useEffect(() => {
    const v = [...allVendors];
    for (let i = v.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [v[i], v[j]] = [v[j], v[i]];
    }
    setVendors(v);
  }, [allVendors]);

  return (
    <section className="vendor-showcase" id="vendors">
      <h2 className="section-title">The Expo Floor</h2>
      <p className="section-subtitle">Premium booths from master craftspeople</p>
      <div className="vendor-booth-grid">
        {vendors.length === 0 && (
          <p className="empty-state">No vendor booths yet — check back soon!</p>
        )}
        {vendors.slice(0, 6).map((vendor, i) => (
          <Link to={`/booth/${vendor.vendorId}`} className="vendor-booth-tile-link" key={i}>
          <div className="vendor-booth-tile">
            <div className="booth-tile-header">
              <div className="booth-tile-logo-wrap">
                {vendor.profileImageUrl ? (
                  <img src={vendor.profileImageUrl} alt={vendor.businessName} className="booth-tile-logo" />
                ) : (
                  <div className="booth-tile-logo-placeholder">🪵</div>
                )}
              </div>
              <h3>{vendor.businessName}{vendor.liveStreamId && <span className="tile-live-dot"></span>}</h3>
              <p className="vendor-specialty">{vendor.specialty || 'Woodworking'}</p>
            </div>
            <div className="booth-tile-marquee">
              <div className={`marquee-track ${(vendor.itemPreviews || []).length > 3 ? 'animate' : ''}`}>
                {(vendor.itemPreviews || []).map((item, idx) => (
                  <div className="marquee-thumb" key={idx}>
                    {item.images && item.images.length > 0 ? (
                      <img src={item.images[0].url} alt={item.name} />
                    ) : (
                      <div className="marquee-thumb-placeholder">🔨</div>
                    )}
                    <span className="marquee-thumb-price">${(item.price / 100).toFixed(2)}</span>
                  </div>
                ))}
                {(vendor.itemPreviews || []).length > 3 && (vendor.itemPreviews || []).map((item, idx) => (
                  <div className="marquee-thumb" key={`dup-${idx}`}>
                    {item.images && item.images.length > 0 ? (
                      <img src={item.images[0].url} alt={item.name} />
                    ) : (
                      <div className="marquee-thumb-placeholder">🔨</div>
                    )}
                    <span className="marquee-thumb-price">${(item.price / 100).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="booth-tile-footer">
              <span className="vendor-items-count">{vendor.publishedItems} item{vendor.publishedItems !== 1 ? 's' : ''}</span>
              {!hasAccess && !customer && <span className="lock-indicator">🔒</span>}
            </div>
          </div>
          </Link>
        ))}
      </div>
      {vendors.length > 6 && (
        <div className="view-more-link">
          <Link to="/artisans">View more artisans →</Link>
        </div>
      )}
    </section>
  );
}

export default VendorShowcase;
